export const routesModel = [
  {
    name: "profile",
    path: "",
  },
  {
    name: "chat",
    path: "/chat",
  },
  {
    name: "general",
    path: "/general",
  },
  {
    name: "parameters",
    path: "/parameters",
  },
  {
    name: "image",
    path: "/image",
  },
  {
    name: "service",
    path: "/intim",
  },
];
export const routesClient = [
  {
    name: "profile",
    path: "",
  },
  {
    name: "chat",
    path: `/chat`,
  },
];
export const routesAdmin = [
  {
    name: "Models",
    path: "",
  },
  {
    name: "Parameters",
    path: "/parameters",
  },
  {
    name: "Club",
    path: "/image",
  },
  {
    name: "Services",
    path: "/intim",
  },
  {
    name: "Beschwerden",
    path: "/claim",
  },
];
